import {AgGridModule} from 'ag-grid-angular';
import {LfsaBotonsGridComponent} from '../../shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import {LfsaBotonEditarGridComponent} from '../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../shared/shared.module';
import {MantenimientoGaritasComponent} from './views/mantenimiento-garitas/mantenimiento-garitas.component';
import {NotificacionesComponent} from './views/notificaciones/notificaciones.component';
import {MantenimientoBasculasComponent} from './views/mantenimiento-basculas/mantenimiento-basculas.component';
import {OrdenesReferenciaMaquinaComponent} from './views/ordenes-referencia-maquina/ordenes-referencia-maquina.component';
import {TicketAutorizacionTransporteComponent} from './views/ticket-autorizacion-transporte/ticket-autorizacion-transporte.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BalanzaRoutingModule} from './balanza-routing.module';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {TiposOrdenesBalanzaComponent} from './views/tipos-ordenes-balanza/tipos-ordenes-balanza.component';
import {ParametroFactorConversionComponent} from './views/parametro-factor-conversion/parametro-factor-conversion.component';
import {OrdenesDeBalanzaComponent} from './views/ordenes-de-balanza/ordenes-de-balanza.component';
import {ParametrizarValorFleteComponent} from './views/parametrizar-valor-flete/parametrizar-valor-flete.component';
import {DesbloqueoOrdenBalanzaComponent} from './views/desbloqueo-orden-balanza/desbloqueo-orden-balanza.component';
import {FourDigitDecimalNumberDirective} from './directives/Four-Digit-Decimal-Number.directive';
import {DesbloqueoOrdenBalanzaCalidadComponent} from './views/desbloqueo-orden-balanza-calidad/desbloqueo-orden-balanza-calidad.component';
import {PorcentajeMermaAsigClientComponent} from './views/porcentaje-merma-asig-client/porcentaje-merma-asig-client.component';
import {TwoDigitDecimaNumberDirective} from './directives/two-digit-decima-number.directive';
import {UsuarioBasculaGaritaComponent} from './views/usuario-bascula-garita/usuario-bascula-garita.component';
import {PorcentajeToleranciaNivelesPesoComponent} from './views/porcentaje-tolerancia-niveles-peso/porcentaje-tolerancia-niveles-peso.component';
import {SearchCmbBoxPipe} from './pipes/filter-search-cmb.pipe';
import {NotaMaquilaComponent} from './views/nota-maquila/nota-maquila.component';
import {UsuariosAprobadoresComponent} from './views/usuarios-aprobadores/usuarios-aprobadores.component';
import {ConfiguracionMotivosDeDesbloqueosComponent} from './views/configuracion-motivos-de-desbloqueos/configuracion-motivos-de-desbloqueos.component';
import {ParametrizacionesDeCalidadRecibidaComponent} from './views/parametrizaciones-de-calidad-recibida/parametrizaciones-de-calidad-recibida.component';
import {ParametrizacionesDeFactoresConversionComponent} from './views/parametrizaciones-de-factores-conversion/parametrizaciones-de-factores-conversion.component';
import {MantenimientoOrigenesExtractorasComponent} from './views/mantenimiento-origenes-extractoras/mantenimiento-origenes-extractoras.component';
import {KardexComponent} from './views/kardex/kardex.component';
import {ReporteriaComponent} from './views/reporteria/reporteria.component';
import {OrdenesDeBalanzaSalidaComponent} from './views/ordenes-de-balanza-salida/ordenes-de-balanza-salida.component';
import { MantenedorTanquerosComponent } from './views/mantenedor-tanqueros/mantenedor-tanqueros.component';
import { OrdenesCerradasComponent } from './views/ordenes-cerradas/ordenes-cerradas.component';
import { OrdenesCambiarEstadosComponent } from './views/ordenes-actualiza-estados/ordenes-actualiza-estados.component';
import { ReporteComprasComponent } from './views/reporte-compras/reporte-compras.component';
import { OrdenesReasignacionComponent } from './views/ordenes-reasignacion/ordenes-reasignacion.component';
import { MantenedorNivelesDobiComponent } from './views/mantenedor-niveles-dobi/mantenedor-niveles-dobi.component';
import { ReporteQmComponent } from './views/reporte-qm/reporte-qm.component';
import { FormsModule } from '@angular/forms';
import { ReporteGaritaComponent } from './views/reporte-garita/reporte-garita.component';

const DIRECTIVES = [
  TwoDigitDecimaNumberDirective,
  FourDigitDecimalNumberDirective
];

const PIPES = [
  SearchCmbBoxPipe
];

@NgModule({
  declarations: [
    MantenimientoGaritasComponent,
    NotificacionesComponent,
    TicketAutorizacionTransporteComponent,
    OrdenesReferenciaMaquinaComponent,
    MantenimientoBasculasComponent,
    TiposOrdenesBalanzaComponent,
    ParametroFactorConversionComponent,
    OrdenesDeBalanzaComponent,
    ParametrizarValorFleteComponent,
    DesbloqueoOrdenBalanzaCalidadComponent,
    DesbloqueoOrdenBalanzaComponent,
    NotaMaquilaComponent,
    UsuariosAprobadoresComponent,
    ConfiguracionMotivosDeDesbloqueosComponent,
    PorcentajeMermaAsigClientComponent,
    ParametrizacionesDeCalidadRecibidaComponent,
    ParametrizacionesDeFactoresConversionComponent,
    MantenimientoOrigenesExtractorasComponent,
    ReporteriaComponent,
    KardexComponent,
    OrdenesDeBalanzaSalidaComponent,
    OrdenesCerradasComponent,
    OrdenesCambiarEstadosComponent,
    ReporteComprasComponent,
    OrdenesReasignacionComponent,
    ...DIRECTIVES,
    ...PIPES,
    UsuarioBasculaGaritaComponent,
    PorcentajeToleranciaNivelesPesoComponent,
    MantenedorTanquerosComponent,
    MantenedorNivelesDobiComponent,
    ReporteQmComponent,
    ReporteGaritaComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    BalanzaRoutingModule,
    ReactiveFormsModule,
    AgGridModule.withComponents([LfsaBotonEditarGridComponent, LfsaBotonsGridComponent]),
    NgMultiSelectDropDownModule.forRoot()
  ],
})
export class BalanzaModule {
}
